/* eslint-disable jsx-a11y/alt-text */

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Mousewheel } from "swiper/modules";
import PhotoParentheses from "../components/photo-parentheses";
import { mousewheel } from "../App";

const Section8 = ({ onSlideChange }) => {
  return (
    <Swiper
      className="spread_box"
      direction="vertical"
      mousewheel={mousewheel}
      nested
      speed={0}
      effect="fade"
      preventInteractionOnTransition
      modules={[EffectFade, Mousewheel]}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide>
        <div className="icon_wrap">
          <div className="text_wrap">
            <PhotoParentheses />
            <p className="text">Lockin’ Your Moment</p>
          </div>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="icon_wrap">
          <div className="text_wrap">
            <PhotoParentheses isAnimate />
            <p className="text hide">Lockin’ Your Moment</p>
          </div>
        </div>
        <picture className="center_image animate">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_3_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_3_mob.png" />
        </picture>
      </SwiperSlide>
      <SwiperSlide>
        <div className="icon_wrap">
          <div className="text_wrap">
            <PhotoParentheses isActive />
            <p className="text">Lockin’ Your Moment</p>
          </div>
        </div>
        <picture className="side_image">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_1_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_1_mob.png" />
        </picture>
        <picture className="side_image">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_2_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_2_mob.png" />
        </picture>
        <picture className="center_image">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_3_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_3_mob.png" />
        </picture>
        <picture className="side_image">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_4_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_4_mob.png" />
        </picture>
        <picture className="side_image">
          <source
            srcSet="//www.locknlock.com/kor/image/common/about/brand/image_symbol_5_pc.png"
            media="(min-width: 768px)"
          />
          <img src="//www.locknlock.com/kor/image/common/about/brand/image_symbol_5_mob.png" />
        </picture>
      </SwiperSlide>
    </Swiper>
  );
};

export default Section8;
